import { Link } from "react-router-dom";
import { Icon } from "../Icon";

// Header of the list and detail pages: title, a few facts ("24 totals", ...) and, at the right, the page
// actions (view switch, "new ...", "edit" + "more"). Detail pages also pass `back` (a link to the parent page
// `{ to, label }`, or a history back `{ onClick, label }`) and a `status` shown next to the title. A fact is a
// string or, when it carries markup (a due date with how late it is), `{ key, content }`.
// Styles: styles/shared/_page_header.scss.
const BackLink = ({ to, onClick, label }) => {
  const content = (
    <>
      <Icon icon="fa-arrow-left" aria-hidden="true" />
      {label}
    </>
  );
  return to !== undefined ? (
    <Link to={to} className="page_header_back">
      {content}
    </Link>
  ) : (
    <button type="button" className="page_header_back" onClick={onClick}>
      {content}
    </button>
  );
};

const PageHeader = ({ title, facts = [], back, status, children }) => (
  <header className="page_header">
    {back && <BackLink {...back} />}
    <h2 className="page_header_title">{title}</h2>
    {status && <span className="page_header_status">{status}</span>}
    {facts.filter(Boolean).map((fact) => (
      <p key={fact.key ?? fact} className="page_header_fact">
        {fact.content ?? fact}
      </p>
    ))}
    {children && <div className="page_header_actions">{children}</div>}
  </header>
);

export default PageHeader;
